const LoginSucess = () => {
  return (
    <div>
      <h1>Login Successfully!</h1>
    </div>
  )
}

export default LoginSucess
